module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABHElEQVRIS+2WrU4DQRSFzxnXUE9foGAQ4HkCTF8Dg2hCAmL3zs5QARUkOAgvgUaTIMHw43D82CakGPaQFU0gAbYLuwLSkTM357tzZu7MZZp6A7kOoAOAqGcIwCOkQ6aW3QO6BXlF6bkOfZFzyLEEYrEA5ISGMYbtOsQnGmZ+KHCzAIjQXgOAXYFb/xjgvV/Ic6xNcy7O4TSEcP0+1sx/b1Fi2QWB5WkAAi4HMVupBOj391vt9qj3AUAlBMeSjgGOJmvO6SSE8FIJ8FnmqfmzYn4nhtWynZVaNAPMLPqjt8gsOxf02lgdJBY2ALhB9AeNFFqZ6K+fip8CGv8yHwDdgLyjNK6S5VexIluQugC7TCx4QkXbMl9z2/JE6OgNTkInY8flyQ4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/canvasImg/panel/wenben@2x.png
// module id = PzMR
// module chunks = 14